// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"436":"b079eb8f","749":"fdb7759c","926":"4b81d2f8"}[chunkId] + ".chunk.css";
};